import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

      is_loading : true,
      XlsxData   : {},

      //stepdata
      stepData:{
          step_1:'active_step',
          step_2:'disabled_step',
          step_3:'disabled_step',
          step_4:'disabled_step',
          step_5:'disabled_step',
          step_6:'hidden_step'
      },

      formData:{
          step_1:'',
          step_2:'',
          step_3:'',
          step_4:'',
          step_5:'',
          step_6:''
      },

      totalData:{
          total_rail   : '',
          default_rail : '',
          cover_rail   : '',
      }
  },
  mutations: {
      //ローディング
      is_loading (state, payload){
          state.is_loading                    = payload
      },

      //step data
      input_step_data (state, payload){
          state.stepData                      = payload
      },

      //input_form
      input_form_data(state, payload){
          state.formData                      = payload
      },
      //excelData
      loadXlsx(state, payload){
          state.XlsxData                      = payload
      },
      //updateTotal
      update_total_data(state, payload){
          state.totalData                     = payload
      }
  },
  actions: {

  }
})
